export const PUBLIC_TRUST_CENTER_LEGACY = {
  HERO_BANNER: {
    TAGLINE: 'Secure your business and simplify compliance with AI',
  },
  OVERVIEW: {
    PRIVATE_RESOURCES: {
      TITLE: 'Private Resources',
    },
    COMPLIANCE: {
      TITLE: 'Compliance',
    },
    CONTROLS: {
      TITLE: 'Controls',
      UPDATED_ON: (date: string) => `Updated ${date}`,
      VIEW_ALL: 'View all controls',
      MORE_COUNT: (count: number) => `+${count} more`,
    },
    RESOURCES: {
      TITLE: 'Resources',
      VIEW_ALL: 'View all resources',
    },
    SUBPROCESSORS: {
      TITLE: 'Subprocessors',
      VIEW_ALL: (count: number) => `View all ${count} subprocessors`,
      PUBLISHED_DATE: (date: string) => `Published ${date}`,
    },
  },
  CONTROLS: {
    TITLE: 'Controls',
    SEARCH_PLACEHOLDER: 'Search controls...',
  },
  RESOURCES: {
    TITLE: 'Resources',
    SEARCH_PLACEHOLDER: 'Search resources...',
    VIEW: 'View',
    PRIVATE_RESOURCES: {
      TITLE: 'Private Resources',
    },
    PUBLIC_RESOURCES: {
      TITLE: 'Public Resources',
    },
  },
  ERROR: {
    SOMETHING_WENT_WRONG: 'Oops! Something went wrong',
    TITLE: 'Error loading public resources',
    DESCRIPTION: "We couldn't load the public resources. This might be temporary, please try again.",
    RETRY: 'Try again',
    WRONG_EMAIL: 'Wrong email format',
  },
  SUBPROCESSORS: {
    TITLE: 'Subprocessors',
    SEARCH_PLACEHOLDER: 'Search...',
  },
  TABS: {
    OVERVIEW: 'Overview',
  },
  DIALOGS: {
    REQUEST_ACCESS: {
      TRIGGER_BUTTON: 'Request Access',
      TITLE: 'Request Access',
      DESCRIPTION: 'Please fill out all fields below to access this resource.',
      FORM: {
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        EMAIL: 'Email',
        COMPANY: 'Company',
      },
      BUTTONS: {
        CANCEL: 'Cancel',
        SUBMIT: 'Request Access',
      },
      SUCCESS_MESSAGE: 'Access request submitted successfully',
    },
    REQUEST_SUCCESS: {
      TITLE: 'Security Access Request Logged',
      DESCRIPTION: 'Your access request has been recorded for review',
      REQUEST_ID_LABEL: 'REQUEST ID',
      NAME_LABEL: 'Name:',
      EMAIL_LABEL: 'Email:',
      COMPANY_LABEL: 'Company:',
      RESOURCE_LABEL: 'Resource:',
      PROCESS_MESSAGE: 'Access will be provisioned following successful security approval.',
      BUTTON: 'Confirm',
    },
  },
} as const
